<template>
  <div>
    <nav class="navbar"
      v-if="$userInfo">
      <div class="navbar-brand">
        <a class="navbar-item is-active pl-2"
          :href="'#'">
          <img src="@/assets/images/flexiquote-logo.svg"
            alt=""
            width="180"
            height="auto"
            title="Home">
        </a>
        <div class="navbar-burger burger"
          data-target="main-nav-menu"
          @click="toogleBurgerMenu()">
          <span />
          <span />
          <span />
        </div>
      </div>
      <div id="main-nav-menu"
        class="navbar-menu"
        :class="{ 'is-active': burgerMenuActive}">
        <div class="navbar-end">
          <div class="navbar-item">
            <div class="field is-grouped">
              <div class="control notification-message"
                @mouseleave="showNotification = false">
                <a class="button is-info"
                  :data-badge="notificationCount > 0 ? notificationCount : null"
                  :class="[{ 'has-badge-danger has-badge-rounded has-badge-small': notificationCount > 0 }]"
                  @click="toggleNotification($event)">
                  <span class="icon is-small">
                    <i class="mdi mdi-bell mdi-24px" />
                  </span>
                </a>
                <!-- <transition name="custom-classes-transition" enter-active-class="animated bounceIn" leave-class="animated bounceInOut"> -->
                <div v-if="showNotification"
                  class="notification-message-popup animated bounceIn"
                  style="animation-duration: 0.5s">
                  <article class="message is-danger">
                    <div class="message-header">
                      <p>Notifications</p>
                      <button class="delete"
                        @click="toggleNotification()" />
                    </div>
                    <div class="message-body">
                      <expiry-message :licence-data="$license" />
                    </div>
                  </article>
                </div>
                <!-- </transition> -->
              </div>
              <div class="dropdown is-right"
                :class="{ 'is-active': companyDropdownActive }"
                @mouseleave="companyDropdownActive = false">
                <div class="dropdown-trigger">
                  <a class="button is-info"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    @click="toogleDropdown()">
                    <span>{{ $userInfo.companyName }}</span>
                    <span class="icon is-small">
                      <i class="mdi mdi-chevron-down mdi-18px" />
                    </span>
                  </a>
                </div>
                <div class="dropdown-menu"
                  role="menu">
                  <div class="dropdown-content">
                    <div class="dropdown-item dropdown-item-has-icon">
                      <span class="icon"
                        style="color: #5D6D7E;">
                        <i class="mdi mdi-account mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">{{ $userInfo.displayName }}</span>
                    </div>
                    <hr class="dropdown-divider">
                    <a class="dropdown-item dropdown-item-has-icon"
                      href="#"
                      @click="signOut">
                      <span class="icon"
                        style="color: #9B59B6;">
                        <i class="mdi mdi-logout mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Sign Out</span>
                    </a>
                    <hr class="dropdown-divider">
                    <a class="dropdown-item dropdown-item-has-icon"
                      href="#"
                      @click="openAboutModal()">
                      <span class="icon has-text-primary">
                        <i class="mdi mdi-information-variant mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">About</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <about-modal :active.sync="isAboutModalActive"
      :expiry-date="expiryDate"
      @close="closeModal()" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ExpiryMessage from '@/components/ExpiryMessage'
import { AboutModal } from '@/components/BulmaModal'

export default {
  name: 'AppNav',
  components: {
    ExpiryMessage,
    AboutModal
  },
  data: () => {
    return {
      companyDropdownActive: false,
      showNotification: false,
      isAboutModalActive: false,
      burgerMenuActive: false,
      notificationCount: 0,
      showNotification: false
      // licenceData: null
    }
  },
  computed: {
    ...mapGetters(['licenceExpired', 'showSpinnerRequestCount', 'spinnerMessage']),
    randomiseSpinner() {
      return RandomSpinner
    },
    rootUrl: function() {
      return process.env.VUE_APP_ROOT_URI || '/'
    },
    expiryDate: function() {
      if (this.$license) {
        const localDate = new Date(this.$license.expiryDate)
        if (Intl) {
          return Intl.DateTimeFormat(this.$userInfo.locale).format(localDate)
        } else {
          return localDate.toLocaleDateString(this.$userInfo.locale)
        }
      } else {
        return ''
      }
    }
  },
  async created() {
    this.$showSpinner()
    await this.$getLicense()
    if (this.$license.isExpired || this.$license.isExpiring) {
      this.notificationCount++
    } else {
      if (this.notificationCount > 0) {
        this.notificationCount--
      } else {
        this.notificationCount = 0
      }
    }
    this.$hideSpinner()
  },
  methods: {
    ...mapActions(['updateLicenceExpired']),
    signOut() {
      this.$showSpinner()
      this.companyDropdownActive = false
      const jwtToken = this.$cookie.get(this.$cookie.tokenCookieName)
      this.$auth.signOut(jwtToken)
      this.$cookie.delete(this.$cookie.tokenCookieName)
      this.setUserInfo(0)
      this.$hideSpinner()
      this.$router.push('/signin')
    },
    toogleDropdown() {
      this.companyDropdownActive = !this.companyDropdownActive
    },
    openAboutModal() {
      this.companyDropdownActive = false
      this.isAboutModalActive = true
    },
    closeModal() {
      this.isAboutModalActive = false
    },
    toggleNotification(event) {
      if (this.notificationCount > 0) {
        this.showNotification = !this.showNotification
      }
    },
    toogleBurgerMenu() {
      this.burgerMenuActive = !this.burgerMenuActive
    }
  }
}
</script>